<template>
    <div>
        
        <v-container fluid class="px-0 search-doctor-banner pb-0 d-flex justify-center align-center" :style="$vuetify.breakpoint.mdAndUp ? 'min-height: 230px' : 'min-height: 175px'">
            <v-container class="" >
                <v-row no-gutters>                    
                    <v-col cols="12" md="6" offset-md="3">
                        <div v-if="$route.query.video == 1" class="darkergray--text playfair-display mb-2 weight-semibold text-center" :class="$vuetify.breakpoint.mdAndUp ? 'font-32' : 'font-16'">
                          Get on-demand consultations as and when you need them.
                        </div>
                        <div v-else class="darkergray--text playfair-display mb-2 weight-semibold text-center" :class="$vuetify.breakpoint.mdAndUp ? 'font-32' : 'font-16'">
                          Book appointments with top-rated doctors near you.
                        </div>
                    </v-col>                    
                </v-row>
            </v-container>
        </v-container>
        <v-container style="margin-top:-50px;" v-if="$vuetify.breakpoint.mdAndUp">
            
            <v-row class="hidden-sm-and-down">
          
                <v-col cols="12" sm="12" :md="this.searchDoctorRequest.type == 'clinic' ? '10' : '8'" :offset-md="this.searchDoctorRequest.type == 'clinic' ? '1' : '2'">
                    
                    <v-card class="card-shadow" >
                        <v-card-text class="pb-1">
                            <v-row no-gutters>
                                <v-col :md="this.searchDoctorRequest.type == 'clinic' ? '6' : '10'">
                                    <v-autocomplete
                                        class="docauto"
                                        v-model="doctorOrSpecialityId"
                                        :items="doctorAndSpecializations"
                                        solo text
                                        flat
                                        prepend-inner-icon="mdi-account"
                                        color="#9b9b9b"
                                        dense
                                        item-text="name"
                                        item-value="id"
                                        :allow-overflow="false"
                                        clearable
                                        :search-input.sync="searchSync"
                                        placeholder="Search For Doctor or Specialization..."
                                >
                                    <template v-slot:item="data">
                                        <template v-if="typeof data.item !== 'object'">
                                            <v-list-item-content v-text="data.item"></v-list-item-content>
                                        </template>
                                        <template v-else>
                                            <v-list-item-avatar>
                                                <v-avatar class="white--text primary">{{ data.item.name[0] }}</v-avatar>
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                                <v-list-item-subtitle v-html="data.item.group"></v-list-item-subtitle>
                                            </v-list-item-content>
                                        </template>
                                    </template>
                                </v-autocomplete>
                                </v-col>

                                <v-col md="4" class="my-0 py-0 pl-4" v-if="this.searchDoctorRequest.type == 'clinic'">                                
                                    <div class="d-flex align-center">
                                        
                                        <place-autocomplete
                                            ref="place_autocomplete"
                                            :place_name="placeFilter.place_name"
                                            v-on:placechanged="getAddressData"
                                            v-on:locationRemoved="removeLocation"                                            
                                        ></place-autocomplete>
                                        
									    
                                    </div>
                                </v-col>
                                <v-col md="2" class="pl-4 d-flex justify-end">
                                    <v-btn outlined class="searchbtn weight-semibold" 
                                    style="width:100%"
                                            @click="searchButtonClick(false)">Search
                                    </v-btn>
                                </v-col>
                            </v-row>
                            
                        </v-card-text>
                    </v-card>
                </v-col>
                                
            </v-row>
        </v-container>
        <v-container class="hidden-md-and-up" v-if="$vuetify.breakpoint.smAndDown" style="margin-top:-40px;">
            <v-row no-gutters >
                <v-col cols="12">                                    
                    <v-card class="pt-3 pb-0 card-shadow">
                        <v-card-text>    
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <v-autocomplete
                                        hide-details="true"
                                        prepend-inner-icon="mdi-account"
                                        dense
                                        class="docauto"
                                        color="#9b9b9b"
                                        v-model="doctorOrSpecialityId"
                                        :items="doctorAndSpecializations"
                                        solo text
                                        item-text="name"
                                        item-value="id"
                                        :allow-overflow="false"
                                        clearable                            
                                        :search-input.sync="searchSync"
                                        placeholder="Search For Doctor or Specialization..."
                                    >
                                        <template v-slot:item="data">
                                            <template v-if="typeof data.item !== 'object'">
                                                <v-list-item-content v-text="data.item"></v-list-item-content>
                                            </template>
                                            <template v-else>
                                                <v-list-item-avatar>
                                                    <v-avatar class="white--text primary">{{ data.item.name[0] }}
                                                    </v-avatar>
                                                </v-list-item-avatar>
                                                <v-list-item-content>
                                                    <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                                    <v-list-item-subtitle
                                                            v-html="data.item.group"></v-list-item-subtitle>
                                                </v-list-item-content>
                                            </template>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12" class="my-0 py-0 mt-4" v-if="this.searchDoctorRequest.type == 'clinic'">                                
                                    <place-autocomplete
                                    ref="place_autocomplete"
                                    :place_name="placeFilter.place_name"
                                            v-on:placechanged="getAddressData"
                                            v-on:locationRemoved="removeLocation"                                            
                                        ></place-autocomplete>
                                   
                                </v-col>
                                <v-col cols="12" class="d-flex justify-center mt-2">
                                    <v-btn outlined class="searchbtn weight-semibold" 
                                            @click="searchButtonClick(false)">Search
                                    </v-btn>
                                </v-col>
                            </v-row>
                            
                        </v-card-text>
                    </v-card>
                </v-col>                                    
                <!-- <v-col cols="12" class="text-center">
                    <v-btn class="accent-gradient white--text" large
                            @click="searchDoctors(false)">Search
                    </v-btn>
                </v-col> -->
            </v-row>
        </v-container>
        <v-container class="pt-0">
            <!--            Doctor List-->
            <v-row v-if="searchingDoctors && searchDoctorRequest.page <= 1" class="text-center">
                <v-col cols="12">
                    <br><br><br>
                    <v-progress-circular
                            size="50"
                            color="primary"
                            indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="3" class="px-5 hidden-sm-and-down" v-if="showDoctorFilters" style="border-right:1px solid rgba(0, 0, 0, 0.12)">

                    <div class="filter_container">
                        <v-row no-gutters>
                           <v-col cols="6" sm="6">
                                <v-icon right small class="ml-0 pd-0 darkergray--text">mdi-filter-outline</v-icon>
                                <span class="font-14 weight-semibold darkergray--text">Filters</span>
                            </v-col>
                            <v-col cols="6" sm="6" class="text-right">
                                <span class="font-12 weight-medium darkergray--text cursor-pointer" @click="clearFilters()">Reset All</span>
                            </v-col>
                       </v-row>
                       <v-row class="" v-if="this.searchDoctorRequest.type == 'video' || this.searchDoctorRequest.type == ''">
                           <v-col cols="12" class="py-0">
                                <v-divider>
                                </v-divider>
                            </v-col>
                           <v-col cols="12" class="mt-2">                                
                                <span class="font-14 weight-semibold darkergray--text">Location</span>
                            </v-col>                            
                            <v-col cols="12" class="my-0 py-0">                                
                                <div class="d-flex">
                                   
                                    <place-autocomplete
                                    ref="place_autocomplete"
                                    :place_name="placeFilter.place_name"
                                            v-on:placechanged="getAddressData"
                                            v-on:locationRemoved="removeLocation"                                            
                                        ></place-autocomplete>
                                    
                                </div>
                            </v-col>
                       </v-row> 
                       
                       <v-row class="" >
                            <v-col cols="12" class="mt-6">
                                <v-divider>
                                </v-divider>
                            </v-col>
                                                                                
                            <v-col cols="12" class="my-0 py-0">
                                <v-list>
                                    <v-list-group                                                                                                                                                                
                                        no-action
										:value="true"
                                        class="pa-0 ma-0 mc_d"
                                    >
                                        <template v-slot:activator class="ma-0 pa-0">
                                            <v-list-item-content class="pa-0 ma-0 ">
                                                <span class="font-14 weight-semibold darkergray--text">Medical Center</span>
                                            </v-list-item-content>
                                        </template>
                                        <div class="pa-0">
                                            <v-row no-gutters>
                                                <v-col cols="12">
                                                    <v-text-field
                                                    prepend-inner-icon="mdi-magnify"
                                                        v-model="clinicFilter.clinic_search_sync"
                                                        label="Search"
                                                        clearable
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" class="py-0" style="overflow-y:auto; max-height:240px">
                                                    <template v-if="clinicFilter.filteredClinics.length">
                                                        <div
                                                            class="pa-0 ma-0 pl-3"                                                            
                                                            v-for="clinic in clinicFilter.filteredClinics"
                                                            :key="clinic.id"                                                        
                                                        >
                                                            
                                                                <v-checkbox
                                                                hide-details
                                                                dense
                                                                color="darkergray"                                                                
                                                                class="pa-0 ma-0 mt-2 weight-medium clinic_checkbox font-12"
                                                                v-model="clinicFilter.clinic_ids"
                                                                :label="clinic.name"
                                                                :value="clinic.id"
                                                                ></v-checkbox>                                                        
                                                            
                                                        </div>
                                                    </template>
                                                    
                                                    <div v-else class="text-center font-12 weight-semibold">
                                                        No Data Found
                                                    </div>                                                    
                                                </v-col>
                                            </v-row>                                            
                                            
                                        </div>
                                    </v-list-group>
                                </v-list>                                
                                
                            </v-col>
                       </v-row> 
                       <v-row class="mt-4 my-0">
                           <v-col cols="12" class="py-0">
                                <v-divider>
                                </v-divider>
                            </v-col>
                           <v-col cols="12" class="mt-2">                                
                                <span class="font-14 weight-semibold darkergray--text">Gender</span>
                            </v-col>
                            <v-col cols="12" class="my-0 py-0">                           
                                <v-radio-group
                                    class="my-0 py-0"
                                    v-model="filters.gender"
                                    row
                                >
                                    <v-radio
                                        class="my-0 py-0"
                                        label="Male"
                                        value="Male"
                                        color="primary"
                                    ></v-radio>
                                    <v-radio
                                        class="my-0 py-0"
                                        label="Female"
                                        value="Female"
                                        color="primary"
                                    ></v-radio>
                                    <v-radio
                                        class="my-0 py-0"
                                        label="All"
                                        value="All"
                                        color="primary"
                                    ></v-radio>                                    
                                </v-radio-group>                                     
                            </v-col>                            
                       </v-row>
                       <v-row class="">
                           <v-col cols="12" class="py-0">
                                <v-divider>
                                </v-divider>
                            </v-col>
                           <v-col cols="12" class="mt-2">                                
                                <span class="font-14 weight-semibold darkergray--text">Price Range</span>
                            </v-col>
                            <v-col cols="12" class="my-0 py-0">                                
                                <span class="font-14 weight-semibold darkergray--text">₹{{ filters.priceRange[0] }} -  ₹{{ filters.priceRange[1] }}</span>
                            </v-col>
                            <v-col cols="12" class="my-0 py-0">                                
                                <v-range-slider
                                class="pa-0 ma-0"
                                color="darkergray"
                                    :min="filters.minPrice"
                                    :max="filters.maxPrice"
                                    v-model="filters.priceRange"                                    
                                >
                                </v-range-slider>
                            </v-col>
                       </v-row>
                         
                       <v-row>
                            <v-col cols="12" class="text-center mt-6">
                                <v-btn color="secondaryVariant white--text" @click.prevent="applyFilters()">
                                Apply Filters
                            </v-btn>                 
                            </v-col>
                       </v-row>
                    </div>                                              

                </v-col>
                
                <v-col cols="12" sm="12" md="9" class="pl-6">
                    <v-row v-if="doctorList.length" v-scroll.passive="onScrollDoctorList">
                        <v-col cols="12">                            
                            <h3 style="display:inline-block;">Doctors Around You </h3>                             
                            <span class="ml-3 caption">({{pluralize(totalRecords,"Record")}})</span>
                        </v-col>                        
                        <v-col cols="11" class="">                            
                            <v-card tile class="card-shadow">
                                <v-card-text class="pa-0">								
                                        <new-date-picker :default_date="date_filter" v-model="date_filter"></new-date-picker>
                                </v-card-text>
                            
                            </v-card>

                        </v-col>     
                        <v-col cols="1" class="pl-0 py-0">   
                            <v-menu
                                    ref="date_menu"
                                    v-model="date_menu"
                                    transition="scale-transition"                                                                        
                                    :close-on-content-click="false"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-card tile class="card-shadow fill-height d-flex  justify-center align-center" v-on="on">
                                        <div class="d-flex flex-column justify-center align-center">								
                                                <template v-if="$vuetify.mdAndUp">
                                                    <v-icon color="primary" medium class="ma-0 pa-0">mdi-calendar</v-icon>
                                                    <div class="weight-semibold font-12">
                                                        {{ moment(date_filter,'YYYY-MM-DD').format('MMM') }}
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <v-icon color="primary" small class="ma-0 pa-0">mdi-calendar</v-icon>
                                                    <div class="weight-semibold font-10">
                                                        {{ moment(date_filter,'YYYY-MM-DD').format('MMM') }}
                                                    </div>
                                                </template>
                                        </div>
                                        
                                    
                                    </v-card>
                                   
                                </template>
                                
                                <v-date-picker
                                        ref="picker"
                                        v-model="date_filter"                                        
                                        :min="moment().toISOString()"  
                                        @change="onFilterDateSelected($refs)"                                      
                                >
                                    
                                </v-date-picker>
                            </v-menu>

                            

                        </v-col>                        
                        <v-col cols="12" style="height:60px;">
                        </v-col>
                        <v-col cols="12" sm="12" v-for="doctor in doctorList" :key="doctor.id" class="mt-12">
                            
                            <v-card class="card-shadow" v-if="$vuetify.breakpoint.mdAndUp">
                                <v-card-text class="pa-0">
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="8" >
                                            <v-row no-gutters>
                                                <v-col cols="4" sm="4" md="4" class="pa-0 pl-8 pr-8 shift_up">
                                                    <div style="position:relative;" class="square">
														<div class="square_content">
															<div style="width:100%;height:100%;position:relative;">
																
																<div v-if="doctor.profile_image_path" class="round_img pic-shadow" :style="{ 'background-image': 'url(' + apiUrl +'/storage/'+doctor.profile_image_path + ')' }" style="margin-top:-20px !important">
																</div>
																<div v-else class="round_img pic-shadow" style="background-image: url('/general/profile_placeholder.svg');" >
																</div> 
																<v-img
                                                                    v-if="doctor.status == 1"
                                                                    width="22" 
                                                                    :aspect-ratio="1/1" 
                                                                    src="/general/check_circle.png" 
                                                                    max-width="24" style="position:absolute;bottom:8%;right:8%;"
                                                                >
                                                                </v-img>
															</div>															
														</div>
														
													</div>
                                                    <div class="text-center mt-2 weight-regular font-14 cursor-pointer" @click="showDoctorProfile(doctor)">
                                                        View Profile
                                                    </div> 
                                                </v-col>
                                                <v-col cols="8" sm="4" md="6" class="mt-6">
                                                    <div class="darkergray--text weight-bold font-24 cursor-pointer" @click="showDoctorProfile(doctor)">
                                                        {{doctor.salutation}}. {{ doctor.name }}
                                                        
                                                    </div>
                                                    <div v-if="doctor.status != 1"
                                                        class="weight-medium font-12"
                                                    >
                                                        Education Not Verified
                                                    </div>
                                                    <div v-if="doctor.specializations && doctor.specializations.length" class="font-15 weight-semibold darkgray--text mt-1 ">
                                                        {{ doctor.specializations[0].name }}
                                                    </div>
                                                    <div class="mt-1">
                                                        <div class="font-14 weight-regular darkgray--text" v-if="doctor.professional_exp">{{ doctor.professional_exp }} years of experience</div>
                                                        <div v-else class="font-14 weight-regular darkgray--text">Experience not mentioned</div>
                                                    </div>
                                                    <div class="mt-4" v-if="doctor.availableToday == 1">
                                                        <div class="available_today d-flex align-center">
                                                            <span class="dot"></span>
                                                            <span class="ml-2 font-14 weight-medium">Available Today</span>
                                                        </div>                                                                                
                                                    </div>
                                                    <div class="mt-4" v-else>
                                                        <div class="unavailable_today d-flex align-center">
                                                            <span class="dot"></span>
                                                            <span class="ml-2 font-14 weight-medium">Unavailable Today</span>
                                                        </div>                                                                                
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-col>

                                        

                                        <v-col cols="12" sm="12" md="4">
                                            <v-row no-gutters style="min-height:70px !important;">
                                                <v-col cols="12" class="d-flex justify-end">
                                                    
                                                    <div style="position:relative; height:50px;" class="d-flex justify-center align-center ribbon-container">
                                                        <div class="ribbon" style="position:absolute;right:0;">
                                                        </div> 
                                                        <div style="position:absolute;" class="d-flex flex-wrap justify-center">
                                                            
                                                                <span class="font-28 weight-bold secondaryVariant--text">
                                                                    {{getFee(doctor)}}
                                                                </span>
                                                                <span class="font-10 weight-bold secondaryVariant--text">
                                                                    {{getFeeMessage(doctor)}}
                                                                </span>
                                                        </div> 
                                                    </div>
                                                    
                                                </v-col>                                            
                                                <v-col cols="12" class="d-flex flex-wrap justify-end mt-10 pr-8">
                                                    <span class="">
                                                     
                                                        <v-chip label color="red lighten-5" small
                                                                class="red--text ma-0 pa-2"
                                                                v-if="doctor.percent_recommended > 0 && doctor.percent_recommended <50">
                                                                <v-avatar left tile size="5" class="ma-0 pa-0">
                                                                    <v-icon style="font-size:18px" class="ma-0 pa-0">mdi-thumb-up</v-icon>
                                                                </v-avatar>
                                                            <span class="font-16 weight-semibold">{{ doctor.percent_recommended }}%</span>
                                                        </v-chip>                                                       
                                                        <v-chip label color="green lighten-5" small
                                                                class="green--text ma-0 pa-2"
                                                                v-else-if="doctor.percent_recommended >= 50">
                                                                <v-avatar left tile size="5" class="ma-0 pa-0">
                                                                    <v-icon style="font-size:18px" class="ma-0 pa-0">mdi-thumb-up</v-icon>
                                                                </v-avatar>
                                                            <span class="font-16 weight-semibold">{{ doctor.percent_recommended }}%</span>
                                                        </v-chip>
                                                    </span>
                                                    <span class="font-13 weight-semibold green--text ml-2">{{ getRecommendations(doctor) }} </span>
                                                </v-col>
                                            </v-row>
                                             
                                        </v-col>
                                    </v-row>
                                                    
                                    <v-row no-gutters class="pa-8">
                                        <v-col cols="12" sm="12" md="6" class="">
                                            <div v-if="isClinicAvailable(doctor)">
                                                <div class="d-flex align-center">
                                                    <v-icon class="font-20" color="primary" medium right>mdi-map-marker</v-icon>
                                                    <span class="primary--text weight-medium font-16 ml-1">                                                
                                                        {{ doctor.clinics[0].name }}
                                                    </span>
                                                </div>
                                                <div class="ml-8 font-14 weight-light">
                                                    {{doctor.clinics[0].address }}
                                                </div>                           
                                            </div>
                                                             
                                        </v-col>
                                        <v-col cols="12" sm="12" md="6" class="pa-0 d-flex justify-end">
                                            <div class="d-flex justify-end flex-wrap">
                                                <div class="">
                                                    <v-btn 
                                                        class="pa-0 pa-0"
                                                        :class="getClinicConsultationButtonColor().btn"
                                                        tile
                                                        height="48"
                                                        elevation="0"
                                                        style="flex: auto !important;"
                                                        @click="bookClinicAppointmentClicked(doctor)"
                                                    >
                                                        <div class="d-flex px-3 fill-height">
                                                                <div>
                                                                    <v-icon left 
                                                                        class="font-20"
                                                                        :class="getClinicConsultationButtonColor().icon"
                                                                    >
                                                                        mdi-calendar
                                                                    </v-icon>                                                                    
                                                                </div>
                                                                <div class="d-flex flex-column">
                                                                    <span 
                                                                        class="weight-bold font-15" 
                                                                        :class="getClinicConsultationButtonColor().text"
                                                                        style="letter-spacing:normal"
                                                                    >
                                                                        {{getClinicButtonMessage(doctor)}}
                                                                    </span>
                                                                    <span 
                                                                        style="letter-spacing:normal" 
                                                                        class="font-12 weight-semibold"
                                                                        :class="getClinicConsultationButtonColor().text"
                                                                    >{{ getClinicButtonFee(doctor) }}</span>
                                                                </div>
                                                            </div>
                                                        

                                                    </v-btn>               
                                                </div>
                                                <div class="ml-2">
                                                    <v-btn 
                                                        class="pa-0 pa-0"
                                                        :class="getVideoConsultationButtonColor().btn"
                                                        tile
                                                        height="48"
                                                        elevation="0"
                                                        style="flex: auto !important;"
                                                        @click="bookOnlineAppointmentClicked(doctor)"
                                                    >
                                                        <div class="d-flex px-3 fill-height">
                                                                <div>
                                                                    <v-icon left
                                                                     class="font-20"
                                                                     :class="getVideoConsultationButtonColor().icon"
                                                                     >
                                                                        mdi-play-circle-outline
                                                                    </v-icon>                                                                    
                                                                </div>
                                                                <div class="d-flex flex-column">
                                                                    <span 
                                                                        class="weight-bold font-15" 
                                                                        :class="getVideoConsultationButtonColor().text"
                                                                        style="letter-spacing:normal"
                                                                    >
                                                                        {{getOnlineButtonMessage(doctor)}}
                                                                    </span>
                                                                    <span 
                                                                        style="letter-spacing:normal" 
                                                                        class="font-12 weight-semibold"
                                                                        :class="getVideoConsultationButtonColor().text"
                                                                    >{{ getOnlineButtonFee(doctor) }}</span>
                                                                </div>
                                                            </div>
                                                        

                                                    </v-btn>               
                                                </div>
                                                
                                            </div>
                                                                           
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                            <v-card class="card-shadow" v-if="$vuetify.breakpoint.smAndDown">
                                <v-card-text class="pa-0">
                                    <v-row no-gutters>
                                        <v-col cols="5" class="pa-0 pl-8 pr-8 shift_up">
                                            <div style="position:relative;" class="square">
												<div class="square_content">
													<div style="width:100%;height:100%;position:relative;">
														
														<div v-if="doctor.profile_image_path" class="round_img pic-shadow" :style="{ 'background-image': 'url(' + apiUrl +'/storage/'+doctor.profile_image_path + ')' }" style="margin-top:-20px !important">
														</div>
														<div v-else class="round_img pic-shadow" style="background-image: url('/general/profile_placeholder.svg');" >
														</div> 
														<v-img
                                                            v-if="doctor.status == 1"
                                                            width="22" :aspect-ratio="1/1" src="/general/check_circle.png" max-width="24" style="position:absolute;bottom:8%;right:8%;"> </v-img>																
													</div>															
												</div>
												
											</div>
                                            <div class="text-center mt-2 weight-regular font-14" @click="showDoctorProfile(doctor)">
                                                View Profile
                                            </div> 
                                        </v-col>

                                         <v-col offset="1" cols="6" class="d-flex justify-end">
                                                    
                                                    <div style="position:relative; height:50px;" class="d-flex justify-center align-center ribbon-container">
                                                        <div class="ribbon" style="position:absolute;right:0;">
                                                        </div> 
                                                        <div style="position:absolute;" class="d-flex flex-wrap justify-center pl-4">
                                                            
                                                                <span class="font-16 weight-bold secondaryVariant--text">
                                                                    {{getFee(doctor)}}
                                                                </span>
                                                                <span class="font-8 weight-bold secondaryVariant--text">
                                                                    {{getFeeMessage(doctor)}}
                                                                </span>
                                                        </div> 
                                                    </div>
                                                    
                                                </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="12" class="mt-6 px-2">
                                            <div class="darkergray--text weight-bold font-18">
                                                {{doctor.salutation}}. {{ doctor.name }}
                                            </div>
                                            <div v-if="doctor.status != 1"
                                                class="weight-medium font-12"
                                            >
                                                Education Not Verified
                                            </div>
                                            <div v-if="doctor.specializations && doctor.specializations.length" class="font-14 weight-semibold mt-1 darkgray--text">
                                                {{ doctor.specializations[0].name }}
                                            </div>
                                            <div class="mt-1">
                                                <div class="font-14 weight-regular darkgray--text" v-if="doctor.professional_exp">{{ doctor.professional_exp }} years of experience</div>
                                                <div v-else class="font-12 weight-regular darkgray--text">Experience not mentioned</div>
                                            </div>                                            
                                        </v-col>
                                      
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6">
                                            <div class="mt-0 px-2" v-if="doctor.availableToday == 1">
                                                <div class="available_today d-flex align-center">
                                                    <span class="dot"></span>
                                                    <span class="ml-2 font-12 weight-medium">Available Today</span>
                                                </div>                                                                                
                                            </div>
                                            <div class="mt-0 px-2" v-else>
                                                <div class="unavailable_today d-flex align-center">
                                                    <span class="dot"></span>
                                                    <span class="ml-2 font-12 weight-medium">Unavailable Today</span>
                                                </div>                                                                                
                                            </div>
                                        </v-col>
                                        
                                        <v-col cols="6" class="d-flex flex-wrap justify-end">
                                            <div class="pr-2">
                                                <span class="">                                                
                                                    <v-chip label color="red lighten-5" small
                                                            class="red--text ma-0 pa-2"
                                                            v-if="doctor.percent_recommended > 0 && doctor.percent_recommended <50">
                                                            <v-avatar left tile size="5" class="ma-0 pa-0">
                                                                <v-icon style="font-size:18px" class="ma-0 pa-0">mdi-thumb-up</v-icon>
                                                            </v-avatar>
                                                        <span class="font-12 weight-semibold">{{ doctor.percent_recommended }}%</span>
                                                    </v-chip>                                                       
                                                    <v-chip label color="green lighten-5" small
                                                            class="green--text ma-0 pa-2"
                                                            v-else-if="doctor.percent_recommended >= 50">
                                                            <v-avatar left tile size="5" class="ma-0 pa-0">
                                                                <v-icon style="font-size:18px" class="ma-0 pa-0">mdi-thumb-up</v-icon>
                                                            </v-avatar>
                                                        <span class="font-12 weight-semibold">{{ doctor.percent_recommended }}%</span>
                                                    </v-chip>
                                                </span>
                                                <span class="font-12 weight-semibold green--text ml-2">{{ getRecommendations(doctor) }} </span>
                                            </div>
                                        </v-col>
                                        
                                    </v-row>
                                    <v-row no-gutters v-if="isClinicAvailable(doctor)"> 
                                        <v-col cols="12">
                                            <div>
                                                <div class="d-flex align-center">
                                                    <v-icon class="font-18" color="primary" medium right>mdi-map-marker</v-icon>
                                                    <span class="primary--text weight-medium font-16 ml-1">                                                
                                                        {{ doctor.clinics[0].name }}
                                                    </span>
                                                </div>
                                                <div class="ml-7 font-12 weight-light">
                                                    {{doctor.clinics[0].address }}
                                                </div>                           
                                            </div>
                                                             
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="6" class="pa-0 d-flex justify-center">                                            
                                            
                                            <v-btn class="white--text pa-0 pa-0"
                                                tile
                                                height="48"
                                                elevation="0"
                                                style="flex: auto !important;"
                                                @click="bookClinicAppointmentClicked(doctor)"
                                                :class="getClinicConsultationButtonColor().btn"
                                            >
                                                <div class="d-flex px-3 fill-height">
                                                        <div>
                                                            <v-icon left class="font-18"
                                                                :class="getClinicConsultationButtonColor().icon"
                                                            >
                                                                mdi-calendar
                                                            </v-icon>                                                                    
                                                        </div>
                                                        <div class="d-flex flex-column">
                                                            <span class="weight-bold font-12"
                                                                :class="getClinicConsultationButtonColor().text"
                                                                style="letter-spacing:normal">
                                                                {{getClinicButtonMessage(doctor)}}
                                                            </span>
                                                            <span style="letter-spacing:normal"
                                                                :class="getClinicConsultationButtonColor().text"
                                                                class="font-10 weight-semibold">{{ getClinicButtonFee(doctor) }}</span>
                                                        </div>
                                                    </div>                                                

                                            </v-btn>               
                                                                                                                             
                                                                           
                                        </v-col>
                                        <v-col cols="6" class="pa-0 d-flex justify-center">                                                                                    
                                            <v-btn class="pa-0 pa-0"
                                                tile
                                                height="48"
                                                elevation="0"
                                                style="flex: auto !important;"
                                                @click="bookOnlineAppointmentClicked(doctor)"
                                                :class="getVideoConsultationButtonColor().btn"
                                            >
                                            
                                                <div class="d-flex px-3 fill-height">
                                                        <div>
                                                            <v-icon left class="font-18"
                                                                :class="getVideoConsultationButtonColor().icon"
                                                            >
                                                                mdi-play-circle-outline
                                                            </v-icon>                                                                    
                                                        </div>
                                                        <div class="d-flex flex-column">
                                                            <span class="weight-bold font-12"
                                                                :class="getVideoConsultationButtonColor().text"
                                                                style="letter-spacing:normal">
                                                                {{getOnlineButtonMessage(doctor)}}
                                                            </span>
                                                            <span style="letter-spacing:normal"
                                                            :class="getVideoConsultationButtonColor().text"
                                                            class="font-10 weight-semibold">{{ getOnlineButtonFee(doctor) }}</span>
                                                        </div>
                                                    </div>
                                                
                                            </v-btn>                                                       
                                                                           
                                        </v-col>
                                    </v-row>
                                
                                                    
                                    
                                </v-card-text>
                            </v-card>
                            <v-card outlined  v-if="1 === 0">
                                <v-card-text class="pa-0">
                                    <v-row>
                                        <v-col cols="12" sm="12" md="8" class="pb-0 pt-0">
                                            <v-list class="wrap-normal-list">
                                                
                                                    <v-row class="ma-0 pa-0">
                                                        <v-col cols="12" sm="4" md="3"  class="text-center ma-0 pa-0">

                                                            <v-row class="ma-0 pa-0">
                                                                <v-col cols="12" class="ma-0" v-if="doctor.profile_image_path">
                                                                    <div class="round_img" :style="{ 'background-image': 'url(' + apiUrl +'/storage/'+doctor.profile_image_path + ')' }">
                                                                    </div>                                                                            
                                                                </v-col>                                                                
                                                                <v-col cols="12" class="ma-0" v-else>       
                                                                    <div class="round_img" style="background-image: url('/general/profile_placeholder.svg')">
                                                                    </div>                                                               
                                                                </v-col>                      
                                                                <v-col cols="12" class="pa-0 ma-0">
                                                                    <p class="available_online" @click="showDoctorProfile(doctor)">
                                                                        View Profile
                                                                    </p>                                                                                                                                     
                                                                </v-col>
                                                            </v-row>
                                                            
                                                        </v-col>
                                                        
                                                        <v-col cols="12" sm="8" md="9" class="ma-md-0 pa-md-0 pl-xs-2">
                                                            <v-row>
                                                                <v-col cols="12" col md="12" class="ma-0 pa-0">
                                                                    <v-list-item>
                                                                        <v-list-item-content>
                                                                            <v-list-item-title class="font-20 blue--text pointer"
                                                                                            @click="showDoctorProfile(doctor)">{{
                                                                                doctor.salutation }}
                                                                                {{ doctor.name }}
                                                                                <span class="ml-3">
                                                                                    <v-chip label color="grey" small class=""
                                                                                            v-if="!doctor.percent_recommended" outlined>
                                                                                        No Recommendations
                                                                                    </v-chip>
                                                                                    <v-chip label color="orange" small outlined
                                                                                            class="white--text"
                                                                                            v-if="doctor.percent_recommended < 50 && doctor.percent_recommended > 0">
                                                                                        {{ doctor.percent_recommended }}%
                                                                                        <v-icon small right>mdi-thumb-up</v-icon>
                                                                                    </v-chip>
                                                                                    <v-chip label color="green" outlined small
                                                                                            class="white--text"
                                                                                            v-if="doctor.percent_recommended >= 50">
                                                                                        {{ doctor.percent_recommended }}%
                                                                                        <v-icon small right>mdi-thumb-up</v-icon>
                                                                                    </v-chip>
                                                                                </span>
                                                                            </v-list-item-title>
                                                                            <v-list-item-subtitle>
                                                                                <span v-for="specialization in doctor.specializations"
                                                                                    :key="specialization.id">
                                                                                    {{ specialization.name }}
                                                                                </span>
                                                                                <div v-if="doctor.professional_exp" class="mt-1">{{ doctor.professional_exp }} years of professional experience</div>
                                                                                <div v-else class="mt-1">Experience not mentioned</div>
                                                                                <div class="my-2">
                                                                                    <span class="mr-3 hidden-md-and-up">
                                                                                        Fees: <b>Rs.{{ getFee(doctor) }}</b>
                                                                                    </span>
                                                                                    
                                                                                </div>
                                                                                
                                                                            </v-list-item-subtitle>
                                                                        </v-list-item-content>
                                                                    </v-list-item>  
                                                                </v-col>
                                                                 <v-col md="12" class="ma-0 pa-0">
                                                                    <v-list-item class="">
                                                                                                                                               
                                                                        <v-list-item-content v-if="showClinicSection(doctor)">
                                                                            <v-list-item-title>
                                                                                {{ doctor.clinics[0].name }}
                                                                            </v-list-item-title>
                                                                            <v-list-item-subtitle style="margin-left:0px">
                                                                                {{doctor.clinics[0].address }}
                                                                            </v-list-item-subtitle>
                                                                            <div class="hidden-md-and-up mt-4" v-if="doctor.availableToday == 1">
                                                                                <div class="available_today d-flex align-center justify-center">
                                                                                    <v-icon small color="availableToday" medium right>mdi-calendar</v-icon>
                                                                                    <span class="ml-2">Available Today</span>
                                                                                </div>                                                                                
                                                                            </div>
                                                                            <v-btn class="accent white--text mt-4 hidden-md-and-up"
                                                                                style="flex: auto !important;"
                                                                                @click="bookAppointmentClicked(doctor)">Book Appointment
                                                                            </v-btn>               
                                                                            <p v-if="showAvailableOnlineLink(doctor)" @click="goForOnlineBooking(doctor.id)" class="available_online hidden-md-and-up text-center mt-2">
                                                                                Available Online
                                                                            </p>                                                                            
                                                                            
                                                                        </v-list-item-content>
                                                                        <v-list-item-content v-else>
                                                                        
                                                                            <v-list-item-title>                                                                        
                                                                                Video Consultation
                                                                            </v-list-item-title>    
                                                                            <div class="hidden-md-and-up mt-6" v-if="doctor.availableToday == 1">
                                                                                <div class="available_today d-flex align-center justify-center">
                                                                                    <v-icon small color="availableToday" medium right>mdi-calendar</v-icon>
                                                                                    <span class="ml-2">Available Today</span>
                                                                                </div>                                                                                
                                                                            </div>                                                                                                                                              
                                                                            <v-btn class="accent white--text mt-6 hidden-md-and-up"
                                                                                style="flex: auto !important;"
                                                                                @click="bookAppointmentClicked(doctor)">
                                                                                    Book Appointment
                                                                            </v-btn>                                                                                           
                                                                            <p v-if="showBookAtClinicLink(doctor)" @click="showDoctorProfile(doctor)" class="available_online hidden-md-and-up text-center mt-2">
                                                                                Book At Clinic
                                                                            </p>
                                                                            
                                                                        </v-list-item-content>
                                                                        
                                                                    </v-list-item>
                                                                 </v-col>
                                                            </v-row>
                                                        </v-col>
                                                    </v-row>                                                                                                                                                        
                                                
                                            </v-list>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="4" class="hidden-sm-and-down pb-0 mb-0">
                                            <v-list two-line class="wrap-normal-list text-right">
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <!--                                                        <v-list-item-title>Fees: Rs. 60</v-list-item-title>-->
                                                        <v-list-item-subtitle>
                                                            
                                                            <span class="mr-3">
                                                                    Fees: <b>Rs. {{ getFee(doctor) }}</b>
                                                            </span>
                                                            
                                                            <br><br>
                                                            <br>
                                                            
                                                            <br>
                                                            <div class="d-inline-flex flex-column" style="width: 173px;">
                                                                <div class="mt-6" v-if="doctor.availableToday == 1">
                                                                    <div class="available_today d-flex align-center justify-center">
                                                                        <v-icon class="ml-0" small color="availableToday" medium right>mdi-calendar</v-icon>
                                                                        <span class="ml-2">Available Today</span>
                                                                    </div>                                                                                
                                                                </div>
                                                                <v-btn class="accent white--text mt-4 custom-button" text @click="bookAppointmentClicked(doctor)">
                                                                    Book Appointment
                                                                </v-btn>
                                                                <div v-if="showAvailableOnlineLink(doctor)">
                                                                    <p @click="goForOnlineBooking(doctor.id)" class="available_online text-center custom-button float-right mt-3">
                                                                            Available Online
                                                                    </p>                                                                     
                                                                </div>
                                                                <div v-else-if="showBookAtClinicLink(doctor)">
                                                                    <p @click="showDoctorProfile(doctor)" class="available_online text-center custom-button float-right mt-3">
                                                                        Book At Clinic
                                                                    </p>
                                                                </div>
                                                            </div>                                                            
                                                            
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                            
                        </v-col>
                        <v-col cols="12" sm="12" class="text-center">
                            <span>{{ endMessage }}</span>
                        </v-col>
                        <v-col align="center" v-if="searchingDoctors && this.searchDoctorRequest.page > 1" cols="12">
                            
                            <v-progress-circular
                                    size="50"
                                    color="primary"
                                    indeterminate
                            ></v-progress-circular>
                        </v-col>
                        <span id="doc_scroll_obj"></span>
                    </v-row>
                    <v-row v-if="isEmpty" class="text-center mt-12 mb-12">
                        <v-col cols="12" sm="12" class="text-center">
                            <span>No Doctors Found</span>
                        </v-col>
                    </v-row>                    
                    
                </v-col>
                
            </v-row>
        </v-container>

        <!--        Mobile HTML Below -->
        <v-btn
                fixed
                fab
                color="accent"
                left
                bottom
                class="hidden-md-and-up ml-1"
                @click="filterDialog = true"
        >
            <v-icon>mdi-filter</v-icon>
        </v-btn>

        <!--        Filter Modal-->
        <v-dialog v-model="filterDialog" max-width="900">
            <v-card class="pt-6">
                <v-card-text class="pb-0">
                    <div class="filter_container">
                        <v-row no-gutters>
                           <v-col cols="6" sm="6">
                                <v-icon right small class="ml-0 pd-0 darkergray--text">mdi-filter-outline</v-icon>
                                <span class="font-14 weight-semibold darkergray--text">Filters</span>
                            </v-col>
                            <v-col cols="6" sm="6" class="text-right">
                                <span class="font-12 weight-medium darkergray--text" @click="clearFilters()">Reset All</span>
                            </v-col>
                       </v-row>
                       <v-row v-if="this.searchDoctorRequest.type == 'video'">
                           <v-col cols="12" class="py-0">
                                <v-divider>
                                </v-divider>
                            </v-col>
                           <v-col cols="12" class="mt-2">                                
                                <span class="font-14 weight-semibold darkergray--text">Location</span>
                            </v-col>                
                            <v-col cols="12" class="my-0 py-0 mt-4">                                
                                <place-autocomplete
                                ref="place_autocomplete"
                                :place_name="placeFilter.place_name"
                                        v-on:placechanged="getAddressData"
                                        v-on:locationRemoved="removeLocation"                                            
                                    ></place-autocomplete>
                            
                            </v-col>            
                            
                       </v-row> 
                       <v-row class="" >
                            <v-col cols="12" class="mt-6">
                                <v-divider>
                                </v-divider>
                            </v-col>
                                                                                
                            <v-col cols="12" class="my-0 py-0">
                                <v-list>
                                    <v-list-group                                                                                                                                                                
                                        no-action
										:value="true"
                                        class="pa-0 ma-0 mc_d"
                                    >
                                        <template v-slot:activator class="ma-0 pa-0">
                                            <v-list-item-content class="pa-0 ma-0 ">
                                                <span class="font-14 weight-semibold darkergray--text">Medical Center</span>
                                            </v-list-item-content>
                                        </template>
                                        <div class="pa-0">
                                            <v-row no-gutters>
                                                <v-col cols="12">
                                                    <v-text-field
                                                    prepend-inner-icon="mdi-magnify"
                                                        v-model="clinicFilter.clinic_search_sync"
                                                        label="Search"
                                                        clearable
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" class="py-0" style="overflow-y:auto; max-height:240px">
                                                    <template v-if="clinicFilter.filteredClinics.length">
                                                        <div
                                                            class="pa-0 ma-0 pl-3"                                                            
                                                            v-for="clinic in clinicFilter.filteredClinics"
                                                            :key="clinic.id"                                                        
                                                        >
                                                            
                                                                <v-checkbox
                                                                hide-details
                                                                dense
                                                                color="darkergray"                                                                
                                                                class="pa-0 ma-0 mt-2 weight-medium clinic_checkbox font-12"
                                                                v-model="clinicFilter.clinic_ids"
                                                                :label="clinic.name"
                                                                :value="clinic.id"
                                                                ></v-checkbox>                                                        
                                                            
                                                        </div>
                                                    </template>
                                                    
                                                    <div v-else class="text-center font-12 weight-semibold">
                                                        No Data Found
                                                    </div>                                                    
                                                </v-col>
                                            </v-row>                                            
                                            
                                        </div>
                                    </v-list-group>
                                </v-list>                                
                                
                            </v-col>
                       </v-row> 
                       
                       <v-row class="mt-4 my-0">
                           <v-col cols="12" class="py-0">
                                <v-divider>
                                </v-divider>
                            </v-col>
                           <v-col cols="12" class="mt-2">                                
                                <span class="font-14 weight-semibold darkergray--text">Gender</span>
                            </v-col>
                            <v-col cols="12" class="my-0 py-0">                           
                                <v-radio-group
                                    class="my-0 py-0"
                                    v-model="filters.gender"
                                    row
                                >
                                    <v-radio
                                        class="my-0 py-0"
                                        label="Male"
                                        value="Male"
                                        color="primary"
                                    ></v-radio>
                                    <v-radio
                                        class="my-0 py-0"
                                        label="Female"
                                        value="Female"
                                        color="primary"
                                    ></v-radio>
                                    <v-radio
                                        class="my-0 py-0"
                                        label="All"
                                        value="All"
                                        color="primary"
                                    ></v-radio>                                    
                                </v-radio-group>                                     
                            </v-col>                            
                       </v-row>
                       <v-row class="">
                           <v-col cols="12" class="py-0">
                                <v-divider>
                                </v-divider>
                            </v-col>
                           <v-col cols="12" class="mt-2">                                
                                <span class="font-14 weight-semibold darkergray--text">Price Range</span>
                            </v-col>
                            <v-col cols="12" class="my-0 py-0">                                
                                <span class="font-14 weight-semibold darkergray--text">₹{{ filters.priceRange[0] }} -  ₹{{ filters.priceRange[1] }}</span>
                            </v-col>
                            <v-col cols="12" class="my-0 py-0">                                
                                <v-range-slider
                                class="pa-0 ma-0"
                                color="darkergray"
                                    :min="filters.minPrice"
                                    :max="filters.maxPrice"
                                    v-model="filters.priceRange"                                    
                                >
                                </v-range-slider>
                            </v-col>
                       </v-row>
                         
                       
                    </div>       
                </v-card-text>
                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn text @click.prevent="filterDialog = false" class="mr-3">
                        Close
                    </v-btn>
                    <v-btn color="accent" @click.prevent="applyFilters()">
                        Apply Filters
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--        Doctor Profile Modal-->
        <v-dialog :key="selectedDoctor.id" v-model="doctorProfileDialog" :fullscreen="$vuetify.breakpoint.smAndDown" max-width="1200">
            <v-toolbar
                dark          
                v-if="$vuetify.breakpoint.smAndDown"
                color="white"
                
            >
                <v-btn
                    icon
                    dark
                    color="black"                    
                    @click="doctorProfileDialog = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title class="black--text"></v-toolbar-title>
                <v-spacer></v-spacer>
            
            </v-toolbar>
            <v-card>
                
                <doctor-profile :key="selectedDoctor.id" :doctorId="selectedDoctor.id"></doctor-profile>
                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn text @click.prevent="doctorProfileDialog = false" class="">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    
</template>

<script>
    import DoctorProfile from "../components/Doctor/DoctorProfile";	    

    import { gmapApi } from 'vue2-google-maps'
    import NewDatePicker from '../components/NewDatePicker'
    import PlaceAutocomplete from '../components/PlaceAutocomplete.vue';
    
    export default {
        name: "SearchDoctor",
        components: {
            DoctorProfile,
            NewDatePicker,			
            PlaceAutocomplete
    
        },
        computed:{
            google:gmapApi
        },
        
        mounted() {
            
            this.searchDoctorRequest.type = this.getAppointmentType()
            
            this.getClinics()
            this.setAppointmentType();
            this.populate().then(() => {
                this.initSearch()
                
                this.$watch('searchSync',function(){
                    clearTimeout(this._timerId)
                    this._timerId = setTimeout(() => {
                        this.getDoctorAndSpecializationsForAutoComplete()
                    }, 500)

                })
                
            })
            // if(this.$route.params.specialization){
            //     this.doctorAndSpecializations.push(this.$route.params.specialization)
            //     this.doctorOrSpeciality = this.$route.params.specialization
            //     this.searchDoctors();
            // }
            // else{
            //     this.initSearch()
            // }
            
        },
        data() {
            return {
                doctorOrSpecialityId: null,
                apiUrl:process.env.VUE_APP_API_URL,
                doctorOrSpeciality: {},
                doctorAndSpecializations: [],
                selectedDoctor: {},
                doctorProfileDialog: false,
                filterDialog: false,
                showDoctorFilters: false,
                filters: {
                    appointmentType:  {
                        name: 'Clinic',
                        value: 'clinic'
                    },
                    priceRange:[0,2000],
                    minPrice:0,
                    maxPrice:3000,                    
                    maxFees:null,
                    gender:'All',
                    latitude:null,
                    longitude:null,
                    city:null,                    
                    place_name:""
                                       
                },
				date_filter:this.moment().format('YYYY-MM-DD'),
                cityList: ['Mumbai'],
                genderList: [
                    {
                        key:'',
                        value:"All"
                    },
                    {
                        key:'Male',
                        value:"Male"
                    },
                    {
                        key:'Female',
                        value:"Female"
                    }
                ],                
                appointmentTypes: [
                    {
                        name: 'Clinic',
                        value: 'clinic'
                    },
                    {
                        name: 'Video',
                        value: 'video'
                    }
                ],
				autocomplete_type:["regions"],
                searchingDoctors: false,
                searchDoctorRequest: {
                    apiProcessing:false,
                    specialization_id: '',
                    name: '',
                    type:'',
                    gender:'',
                    city: 'Mumbai',
                    limit: 5,
                    formatType: 'pagination',
                },
                doctorList: [],
                pagination: {
                    current_page: 1,
                },
                endMessage: '',
                isEmpty:false,
                
                searchSync:"",
                
                geoLocation:"",
                totalRecords:"",   
                placeFilter:{
                    latitude:null,
                    longitude:null,
                    city:null,                    
                    place_name:""
                },          
                clinicFilter:{
                    clinic_search:"",
                    clinic_search_sync:"",
                    clinic_id:"",
                    clinic_ids:[],
                    allClinics:[],
                    filteredClinics:[],
                },		
                date_menu:false		
                
            }
        },
        methods: {
            getAppointmentType(){
                if(this.$route.query.video == 1)
                    return 'video'
                else if(this.$route.query.clinic == 1)
                    return 'clinic'
                else
                    return ''
            },
            isVideoSearch(){
                return this.$route.query.video == 1
            },
            isClinicSearch(){
                return this.$route.query.clinic == 1
            }
            ,
            setSearchParams() {
                return new Promise((resolve) => {
                    let docAndSpec = JSON.parse(this.$route.query.doctorOrSpeciality)
                    this.doctorAndSpecializations.push({id: docAndSpec.id, name: docAndSpec.searchString})                    
                    this.searchSync = docAndSpec.searchString
                    this.doctorOrSpecialityId = docAndSpec.id
                    resolve()
                })
            },
            findInDocAndSpecialization(data){
                
                if(data.id && data.id === this.doctorOrSpecialityId)                
                    return true
                else return false
                
                
            },
            populate(){
                var ctx = this
                return new Promise((resolve) => {
                    if(this.$route.query.filters) {
                        var fil = JSON.parse(this.$route.query.filters)
                    
                        Object.keys(ctx.filters).forEach(function(key) {
                            
                            if (fil[key] !== undefined){
                                ctx.filters[key] = fil[key];
                            }

                        })
                    }                    
                    // if(this.$route.query.filters) {
                    //     this.filters = JSON.parse(this.$route.query.filters)
                    // }
                    if(this.$route.query.clinics) {
                        this.clinicFilter.clinic_ids = JSON.parse(this.$route.query.clinics)
                    }
                    if(this.$route.query.date_filter) {
                        this.date_filter = this.$route.query.date_filter
                    }
                    let place_filter = {}
                    
                    place_filter.city=this.filters.city;
                    place_filter.latitude=this.filters.latitude;
                    place_filter.longitude=this.filters.longitude;
                    place_filter.place_name=this.filters.place_name;
                    this.placeFilter = place_filter
                    if(this.$route.query.doctorOrSpeciality) {
                        this.setSearchParams().finally(() => {
                            let docAndSpec = JSON.parse(this.$route.query.doctorOrSpeciality)
                            var searchStr =  docAndSpec.searchString
                            this.getDoctorAndSpecializationsForAutoComplete(searchStr).then((data) => {
                                
                                // this.doctorOrSpeciality = data.find((x) => x.id.localeCompare(this.doctorOrSpecialityId))
                                    this.doctorOrSpeciality = data.find(this.findInDocAndSpecialization)
                                      
                                
                            }).finally(() => {
                                resolve()
                            })
                        })
                    } else {
                        resolve()
                    }
                })
            },
            onFilterDateSelected($refs){                
                $refs.date_menu.save(this.date_filter)
                this.date_menu = false
            },
            searchButtonClick(){
                if(this.searchDoctorRequest.type == 'clinic') {
                  this.populateLocationFilters()
                }
                this.doctorOrSpeciality = this.doctorAndSpecializations.find((x) => x.id === this.doctorOrSpecialityId)
                this.reloadPage()
            },
            populateLocationFilters(){
                this.filters.clinic_ids = this.clinicFilter.clinic_ids
                this.filters.city = this.placeFilter.city;
                this.filters.latitude = this.placeFilter.latitude;
                this.filters.longitude = this.placeFilter.longitude;
                this.filters.place_name = this.placeFilter.place_name;
            },
            reloadPage(){
                let filters = JSON.stringify(this.filters)
              let clinics = JSON.stringify(this.clinicFilter.clinic_ids)
              let tempDocSpeciality = null;
              if(this.doctorOrSpeciality){
                    tempDocSpeciality = JSON.stringify({
                        searchString: this.searchSync,
                        group: this.doctorOrSpeciality.group,
                        id: this.doctorOrSpeciality.id
                    })
              }
              let searchGroup = this.getAppointmentType()
              this.$router.replace({path: '/search-doctor', query:
                {
                  filters: filters,
                  clinics: clinics,
                  [searchGroup]: 1,
                  date_filter:this.date_filter,
                  doctorOrSpeciality:tempDocSpeciality
                }
              })
            },
            applyFilters(){                
				window.scrollTo(0,0);
                this.populateLocationFilters()
                this.reloadPage()
                // this.searchDoctors(false)
            },
            getRecommendations(doctor){
                var count = doctor.total_ratings;
                if(count == null)
                    count = 0
                // var count = (doctor.percent_recommended / 100 ) * doctor.total_ratings;
                if(count == 0)
                    return "No Recommendation"
                else
                    return count + " Recommendations"                                
            },
            clearFilters(){
                
                // this.filters.priceRange=[0,2000]
                // this.filters.minPrice=0
                // this.filters.maxPrice=3000
                // this.filters.maxFees=null
                // this.filters.gender='All'
                // this.filters.latitude=null
                // this.filters.longitude=null
                // this.filters.city=null
                //
                // this.clinicFilter.clinic_id=""
                // this.clinicFilter.clinic_search_sync=""
                // this.clinicFilter.clinic_search=""
                this.removeLocation()
              let searchGroup = this.getAppointmentType()
              this.$router.replace({path: '/search-doctor', query: {[searchGroup]: 1}})
                // this.searchDoctors(false)
            
            },
            showDoctorProfile(doctor) {
                let routeData = this.$router.resolve({name: 'DoctorDetails', params: {unique_no: doctor.unique_no, slug: this.getSlugFromString(doctor.name)}});
                window.open(routeData.href, '_blank');
                // this.selectedDoctor = doctor;
                // this.doctorProfileDialog = true
                // this.$router.push({name: 'DoctorDetails', params: {id: doctor.id}});
            },
            getClinics(){                
                this.clinicFilter.clinic_search_sync = []
                this.clinicFilter.clinic_ids = []
                this.axios
                    .get(`${process.env.VUE_APP_API_URL}/api/clinics/filter`, {
                        params: {
                            query:this.clinicFilter.clinic_search_sync,                            
                            city:this.filters.city,
                            latitude:this.filters.latitude,
                            longitude:this.filters.longitude
                        }
                    })
                    .then((response) => {
                        this.clinicFilter.allClinics = response.data.data;
                        this.clinicFilter.filteredClinics = response.data.data;
                    }).catch((error) => {
                    console.log(error);
                });                  

            },
            // selectClinicFromFilter(clinic){
            //     this.filters.clinic_search = clinic.name
            //     this.filters.clinic_id = clinic.id
            // },
            searchDoctors(scroll = false) {
                this.searchDoctorRequest.apiProcessing = true
                this.filterDialog = false;
                this.searchingDoctors = true;
                this.endMessage = '';
                this.isEmpty = false
                var ctx = this
              if(this.$route.query.filters) {
                // this.filters = JSON.parse(this.$route.query.filters)
                var fil = (this.$route.query.filters)
                Object.keys(ctx.filters).forEach(function(key) {
                        
                        if (fil[key] !== undefined){
                            ctx.filters[key] = fil[key];
                        }

                    })
              }
              if(this.$route.query.clinics) {
                this.clinicFilter.clinic_ids = JSON.parse(this.$route.query.clinics)
              }
                if (!scroll) {
                    this.doctorList = [];
                    this.searchDoctorRequest.page = 1;
                }
                if (this.doctorOrSpeciality) {
                    if (this.doctorOrSpeciality.group === 'Doctors') {
                        this.searchDoctorRequest.name = this.doctorOrSpeciality.name;
                        this.searchDoctorRequest.specialization_id = null;
                        this.searchDoctorRequest.city = null
                        this.searchDoctorRequest.latitude = null
                        this.searchDoctorRequest.longitude = null
                    } else {
                        this.searchDoctorRequest.name = null;
                        this.searchDoctorRequest.specialization_id = this.doctorOrSpeciality.id;
                        this.searchDoctorRequest.city = this.filters.city
                        this.searchDoctorRequest.latitude = this.filters.latitude
                        this.searchDoctorRequest.longitude = this.filters.longitude
                    }
                } else {
                    this.searchDoctorRequest.name = null
                    this.searchDoctorRequest.specialization_id = null
                    this.searchDoctorRequest.city = this.filters.city
                    this.searchDoctorRequest.latitude = this.filters.latitude
                    this.searchDoctorRequest.longitude = this.filters.longitude
                }
                this.searchDoctorRequest.clinic_ids = this.filters.clinic_ids;
                this.searchDoctorRequest.min_fees = this.filters.priceRange[0];
                this.searchDoctorRequest.max_fees = this.filters.priceRange[1];
                this.searchDoctorRequest.gender = this.filters.gender;
                this.searchDoctorRequest.timezone = this.$store.getters.timezone
				        this.searchDoctorRequest.date = this.date_filter;
                this.axios
                    .get(`${process.env.VUE_APP_API_URL}/api/doctors`, {
                        params: this.searchDoctorRequest
                    })
                    .then((response) => {
                        this.pagination = response.data.data;
                        if (scroll) {
                            if (this.doctorList.length < response.data.data.total) {
                                this.doctorList = this.doctorList.concat(response.data.data.data);                                
                            }
                        } else {
                            this.doctorList = response.data.data.data;
                        }
                        this.totalRecords = response.data.data.total
                        this.searchingDoctors = false;
                        this.showDoctorFilters = true;
                        if (this.searchDoctorRequest.page === this.pagination.last_page && this.searchDoctorRequest.page > 1) {
                            this.endMessage = "You've reached the end of results";
                        }
                        if(this.doctorList.length === 0)
                            this.isEmpty = true                        
                        else
                            this.isEmpty = false
                            
                    }).catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.searchDoctorRequest.apiProcessing = false
                    })
            },
            bookClinicAppointmentClicked(doctor){
                if(this.isClinicAvailable(doctor))
                    this.$router.push({name: 'bookAppointment', query: {id: doctor.id, type: 'clinic', clinic_id:doctor.clinics[0].id,'date':this.date_filter}});
            },
            bookOnlineAppointmentClicked(doctor){
                if(this.isOnlineAvailable(doctor))
                    this.$router.push({name: 'bookAppointment', query: {id: doctor.id, type: 'online', clinic_id:"",'date':this.date_filter}});                
            },
            bookAppointmentClicked(doctor){
                let type = this.filters.appointmentType;
                
                var apptType = ""
                var clinic_id = ""
                if(type.value == 'clinic'){
                    apptType = 'clinic'
                    clinic_id = doctor.clinics[0].id
                }                    
                else if (type.value == 'video'){
                    apptType = 'online'
                }
                else{
                    var showClinicSection = this.showClinicSection(doctor)
                    if(showClinicSection){
                        clinic_id = doctor.clinics[0].id
                        apptType = 'clinic'
                    }
                        
                    else{
                        clinic_id = ""
                        apptType = 'online'
                    }                        
                }                                    
                this.$router.push({name: 'bookAppointment', query: {id: doctor.id, type: apptType, clinic_id:clinic_id}});
            },
            goForOnlineBooking(doctorId) {                
                var apptType = ""                              
                apptType = 'online'                                                    
                this.$router.push({ name: 'bookAppointment', query: {id: doctorId, type: apptType }});
            },
            setAppointmentType() {
                if (this.isVideoSearch()) {
                    this.filters.appointmentType = {
                        name: 'Video',
                        value: 'video'
                    };
                }
                else if (this.isClinicSearch()) {
                    this.filters.appointmentType = {
                        name: 'Clinic',
                        value: 'clinic'
                    };
                }
                else{
                    this.filters.appointmentType = {
                        name: 'All',
                        value: ''
                    };
                }
            },
            getDoctorAndSpecializationsForAutoComplete(searchStr) {
                var search = ""
                if(searchStr == undefined)
                    search = this.searchSync
                else
                    search = searchStr
                return new Promise((resolve) => {
                    this.axios
                        .get(`${process.env.VUE_APP_API_URL}/api/doctor-speciality`, {
                            params: {
                                name:search,
                                type:this.searchDoctorRequest.type
                            }
                        })
                        .then((response) => {
                            this.doctorAndSpecializations = response.data.data.forAutocomplete;
                            
                            resolve(response.data.data.forAutocomplete)
                        }).catch((error) => {
                        console.log(error);
                    });
                })
            },
            // eslint-disable-next-line no-unused-vars
            removeLocation(){
                this.placeFilter.city = "";
                this.placeFilter.latitude = "";
                this.placeFilter.longitude = "";
                this.placeFilter.place_name = "";
                
            },
            getAddressData(place) {
                
                this.geoLocation = ""
                var location_data = this.getAddressComponents(place)
                
                this.placeFilter.city = location_data.city;
                this.placeFilter.latitude = location_data.latitude;
                this.placeFilter.longitude = location_data.longitude;
                this.placeFilter.place_name = location_data.name;

                
                this.geoLocation = location_data.local_address                                
            },
            isInViewport() {
                var el = document.getElementById("doc_scroll_obj")
                const rect = el.getBoundingClientRect();
                return (
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth)

                );
            },
            onScrollDoctorList() {                
                // if (this.isInViewport() && !this.searchDoctorRequest.apiProcessing) {
                //     if (this.searchDoctorRequest.page < this.pagination.last_page) {
                        
                //         this.searchDoctorRequest.page = this.pagination.current_page + 1;
                //         this.searchDoctors(true);
                //     }
                // }
                let scrollHeight = document.body.scrollHeight;
                let totalHeight = window.scrollY + window.innerHeight;
                let offset = 80
                var footerHeight = document.getElementById("footer").offsetHeight
                scrollHeight -= footerHeight + offset
                if (totalHeight >= scrollHeight && !this.searchDoctorRequest.apiProcessing) {
                    
                    if (this.searchDoctorRequest.page < this.pagination.last_page) {
                        
                        this.searchDoctorRequest.page = this.pagination.current_page + 1;
                        this.searchDoctors(true);
                    }
                }
            },
            geolocate(){
                
                navigator.geolocation.getCurrentPosition(position => {
                    var currentLatLng = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    }                    
                    this.geocodeLatLng(currentLatLng)
                    
                },this.geoLocateError)
            },
           
            initSearch(){
                var ctx = this                
                ctx.searchDoctors()                                                                
            },
            geoLocationSuccess(position){
                var currentLatLng = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                }                    
                this.geocodeLatLng(currentLatLng)
            },

            geoLocateError(error) {
                
                switch(error.code) {
                    case error.PERMISSION_DENIED:
                        try{
                            navigator.permissions.query({name:'geolocation'}).then(function(result) {                                
                                if (result.state == 'granted') {
                                    navigator.geolocation.getCurrentPosition(this.geoLocationSuccess)
                                }
                                else if (result.state == 'denied') {
                                    alert("Location permission denied.")
                                }
                            });
                        }
                        catch(err){
                            alert("Location permission denied.")
                        }                        
                        
                    break;
                    case error.POSITION_UNAVAILABLE:
                        alert("Location information is unavailable.")
                    break;
                    case error.TIMEOUT:
                    alert("The request to get user location timed out.")
                    break;
                    case error.UNKNOWN_ERROR:
                        alert("An unknown error occurred.")
                    break;
                }
            },

            isStrEmpty(str) {
                return (!str || 0 === str.length);
            },
            // getAddressComponents(place) {
            
            //     let city = place.locality
            //     let state = place.administrative_area_level_1
            //     let country = place.country                
            //     let latitude = place.latitude                
            //     let longitude = place.longitude                
                
                
            //     let returnObject = {                                        
            //         city: city ? city : null,
            //         state: state ? state : null,
            //         country: country ? country : null,                    
            //         latitude: latitude ? latitude : null,                    
            //         longitude: longitude ? longitude : null,      
            //         local_address: city              
            //     }               
                
            //     return returnObject
            // },
            getAddressComponents(place) {
                
                let premise = place.address_components.find(addressComponent => addressComponent.types.includes('premise'))
                let route = place.address_components.find(addressComponent => addressComponent.types.includes('route'))
                let sublocality = place.address_components.find(addressComponent => addressComponent.types.includes('sublocality'))
                let postal_code = place.address_components.find(addressComponent => addressComponent.types.includes('postal_code'))
                let city = place.address_components.find(addressComponent => addressComponent.types.includes('locality'))
                let state = place.address_components.find(addressComponent => addressComponent.types.includes('administrative_area_level_1'))
                let country = place.address_components.find(addressComponent => addressComponent.types.includes('country'))
                let address = place.formatted_address                
                
                
                let returnObject = {
                    premise: premise ? premise.long_name : null,
                    route: route ? route.long_name : null,
                    sublocality: sublocality ? sublocality.long_name : null,

                    postal_code: postal_code ? postal_code.long_name : null,
                    city: city ? city.long_name : null,
                    state: state ? state.long_name : null,
                    country: country ? country.long_name : null,
                    address: address ? address : null,
                    latitude: place.geometry.location.lat,
                    longitude: place.geometry.location.lng,
                    name:place.name
                }

                var new_address = "";
                if(!this.isStrEmpty(place.name)){
                    new_address = place.name
                }
                else{
                    var address_arr = []
                    if(!this.isStrEmpty(returnObject.premise))
                        address_arr.push(returnObject.premise)
                    if(!this.isStrEmpty(returnObject.route))
                        address_arr.push(returnObject.route)
                    if(!this.isStrEmpty(returnObject.sublocality))
                        address_arr.push(returnObject.sublocality)
                    
                    if(address_arr.length)
                        new_address = address_arr.join(",")
                    else
                        new_address = returnObject.address                    
                }
                returnObject.local_address = new_address
                
                return returnObject
            },
            geocodeLatLng(latLng){       
                
                this.$refs.place_autocomplete.updateCoordinates(latLng)                                                    
            },
            getFeeObject(doctor){
                if(doctor.display_type === 'clinic' && doctor.clinic_fee){
                    return doctor.clinic_fee
                }
                else if(doctor.display_type === 'online' && doctor.online_fee){
                    return doctor.online_fee
                }
                else return null
            },
            getFee(doctor){
                if(doctor.display_type === 'clinic' && doctor.clinic_fee){
                    return "₹ "+doctor.clinic_fee.amount
                }
                else if(doctor.display_type === 'online' && doctor.online_fee){
                    return "₹ "+doctor.online_fee.amount
                }
                else return null
            },

            getFeeMessage(doctor){
                if(doctor.display_type === 'clinic' && doctor.clinic_fee){
                    return "Clinic Consultation Fee";
                }
                else if(doctor.display_type === 'online' && doctor.online_fee){
                    return "Online Consultation Fee";
                }
                else return null
            },
         
   
getClinicConsultationButtonColor(){
	var colors = {};	
	
	if(this.searchDoctorRequest.type == 'clinic' || this.searchDoctorRequest.type == ''){
		colors = {
			btn:'light-blue lighten-5',
			icon:'light-blue--text text--lighten-3',
			text:'secondaryVariant--text'
		}
	}
	else{
		colors = {
			btn:'lightgray',
			icon:'darkergray--text',
			text:'darkergray--text'
		}
	}
		
	return colors;
	
},

getVideoConsultationButtonColor(){
	var colors = {};	
	
	if(this.searchDoctorRequest.type == 'video' || this.searchDoctorRequest.type == ''){
		colors = {
			btn:'light-blue lighten-5',
			icon:'light-blue--text text--lighten-3',
			text:'secondaryVariant--text'
		}
	}
	else{
		colors = {
			btn:'lightgray',
			icon:'darkergray--text',
			text:'darkergray--text'
		}
	}
		
	return colors;
	
},
 // eslint-disable-next-line no-unused-vars
            getClinicButtonMessage(doctor){
                // if(doctor.display_type === 'clinic'){
                //     return "Book Appointment"
                // }
                // else{
                    return "Clinic Consultation"
                // }
            },            
            getClinicButtonFee(doctor){
                // if(doctor.display_type === 'clinic'){
                //     return "No Booking Fee"
                // }
                // else{
                    if(!this.isClinicAvailable(doctor))
                        return "Unavailable"
                    else if(doctor.clinic_fee){
                        return "₹ "+doctor.clinic_fee.amount
                        //return ""
                    }
                    else{
                        return "Unavailable"
                    }
                // }
            },
          // eslint-disable-next-line no-unused-vars
            getOnlineButtonMessage(doctor){
                // if(doctor.display_type === 'online'){
                //     return "Book Appointment"
                // }
                // else{
                        return "Online Consultation"
                // }
                
            },
            getOnlineButtonFee(doctor){
                // if(doctor.display_type === 'online'){
                //     return "No Booking Fee"
                // }
                // else{
                    if(!this.isOnlineAvailable(doctor))
                        return "Unavailable"
                    else if(doctor.online_fee)
                        return "₹ "+doctor.online_fee.amount;
                    else 
                        return "Unavailable"                    
                // }
                                
            },
            isOnlineAvailable(doctor){
                return doctor.onlineAvailability
            },
            isClinicAvailable(doctor){
                return doctor.available_clinic && doctor.clinics_count > 0
            },
            showAvailableOnlineLink(doctor){

                return doctor.display_type === 'clinic' && doctor.onlineAvailability
                // return (this.filters.appointmentType.value === 'clinic' || this.filters.appointmentType.value === '') && doctor.onlineAvailability
            },
            showBookAtClinicLink(doctor){
                return doctor.display_type === 'online' && doctor.available_clinic && doctor.clinics_count > 0
            },
            showClinicSection(doctor){
                var areClinicsAvailable = doctor.available_clinic && doctor.clinics && doctor.clinics.length;
                return doctor.display_type === 'clinic' && areClinicsAvailable
            },            
            filterClinics(){
                var newList=[]
                var ctx=this
                
                if(!ctx.clinicFilter.clinic_search_sync || ctx.clinicFilter.clinic_search_sync.length == 0)
                    ctx.clinicFilter.filteredClinics = ctx.clinicFilter.allClinics
                else
                {
                    ctx.clinicFilter.allClinics.forEach(function(clinic) {
                    if(clinic.name.toLowerCase().includes(ctx.clinicFilter.clinic_search_sync.toLowerCase()))
                        newList.push(clinic)
                    });
                    ctx.clinicFilter.filteredClinics = newList
                }                
                
            },
          

        },
        watch:{
            'clinicFilter.clinic_search_sync':{
                handler: function () {                             
                    this.filterClinics()
                },
                deep: true
            },
			date_filter(){          
                this.reloadPage()
            },
			
        }
    }
</script>

<style>    

    .available_online{
        text-decoration:underline;
        font-size: 16px;
        font-weight: 500;
        color:#2196F3;
        
    }
    .available_online_mobile{
        text-decoration:underline;        
        font-weight: 500;
        color:#2196F3;
        
    }
    .available_online:hover{
        cursor: pointer;
    }
    .custom-button{
        min-width: 173px !important;
    }
    .available_today{
        color:#01a400;
    }
    .available_today span{
        color:#01a400;
    }

    .unavailable_today{
        color:#d90000;
    }
    .unavailable_today span{
        color:#d90000;
    }
    .unavailable_today .dot{
        
        background-color:#d90000;
    }

    .gmapbox{
        outline:none;
        border-bottom:1px solid #4d4d4d;                   
        border: 1px solid #D3D3D3;
        border-radius: 4px;
        padding-left: 4px;
    }
    .gmapTop{
        outline:none;        
        min-height: 38px;                
        padding-left: 4px;
    }
    .gmapac{
        outline:none;
        border-bottom:1px solid #4d4d4d;           
        padding-left:8px;     
    }
    .action_icon{
        width:32px;
        height:32px;
        display: flex;
        justify-content: center;
        background:#4d4d4d;
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
        padding:4px;
    }
    
    .shift_up{
        margin-top:-40px;
    }
    
    .dot {
        height: 7px;
        width: 7px;        
        border-radius: 50%;
        background-color: #01a400;
    }

.ribbon-container{
    max-width:350px;
    width:100%;
}
.ribbon {
    width:100%; 
    height:0px; 
    border-top:25px solid #e7f5e7;
    border-left:25px solid transparent;
    border-bottom:25px solid #e7f5e7;
}

.searchbtn{
    border:1px solid #9b9b9b;
    background:#f5f5f5;
}

.mc_d > .v-list-group__header {
    padding:0px !important;
}

.square {
  position: relative;
  width: 100%;
}

.square:after {
  content: "";
  display: block;
  padding-bottom: 100%;
}

.square_content {
  position: absolute;
  width: 100%;
  height: 100%;
}

.clinic_checkbox label{
    font-size:14px;
}
</style>